/**
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business i18next に渡す翻訳リソース（ja / en / vi の common namespace）。副作用を持たないため、テストからも実翻訳で描画するために読み込める
 * @graph-connects none
 */
import jaCommon from './locales/ja/common.json';
import enCommon from './locales/en/common.json';
import viCommon from './locales/vi/common.json';

/** @graph-connects none */
export const defaultNS = 'common';
/** @graph-connects none */
export const resources = {
  ja: {
    common: jaCommon,
  },
  en: {
    common: enCommon,
  },
  vi: {
    common: viCommon,
  },
} as const;
